<script>
  import { onMount } from 'svelte';
  import { createScene } from "./perlinProd";
  // import { createScene } from "./perlinProd-shadow";
  let el;
  
  onMount(() => {
    createScene(el)
  });

</script>

<canvas bind:this={el}></canvas>
